import { createContext, useContext } from "react";

const OpenManagePlanContext = createContext<(() => void) | null>(null);

/** Opens the manage-plan modal the settings shell mounts. */
export function useOpenManagePlan(): () => void {
  const fn = useContext(OpenManagePlanContext);
  return fn ?? (() => {});
}

export const OpenManagePlanProvider = OpenManagePlanContext.Provider;
